/* BD HERBS — order tracking (snippets/bd-order-track.liquid)
   Header: the truck link opens a bar under the header (bottom panel on phones).
   Page (/pages/track-order): the form is always shown.
   The status comes from sections/bd-order-status.liquid through the Section Rendering API, no reload. */
if (!customElements.get('bd-order-track')) {
  customElements.define(
    'bd-order-track',
    class BdOrderTrack extends HTMLElement {
      connectedCallback() {
        if (this.bound) return; // a second set of listeners would open and close the panel in one tap
        this.bound = true;
        this.panel = this.querySelector('[data-ot-panel]');
        this.toggle = this.querySelector('[data-ot-toggle]');
        this.backdrop = this.querySelector('.bd-ot__backdrop');
        this.form = this.querySelector('[data-ot-form]');
        this.input = this.querySelector('[data-ot-input]');
        this.submit = this.querySelector('[data-ot-submit]');
        this.result = this.querySelector('[data-ot-result]');
        this.error = this.querySelector('[data-ot-error]');
        this.onKey = this.onKey.bind(this);
        this.onOutside = this.onOutside.bind(this);

        if (this.toggle) {
          this.toggle.addEventListener('click', (event) => {
            event.preventDefault();
            this.isOpen() ? this.close() : this.open();
          });
        }
        this.querySelectorAll('[data-ot-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        if (this.form) this.form.addEventListener('submit', (event) => this.lookup(event));
        if (this.input) this.input.addEventListener('input', () => this.showError(false));
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onOutside);
      }

      isPhone() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      isOpen() {
        return this.panel && !this.panel.hidden;
      }

      open() {
        if (!this.panel) return;
        this.panel.hidden = false;
        if (this.backdrop) this.backdrop.hidden = !this.isPhone();
        this.toggle?.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
        if (this.isPhone()) document.body.classList.add('overflow-hidden-mobile');
        requestAnimationFrame(() => this.input?.focus({ preventScroll: true }));
        document.addEventListener('keydown', this.onKey);
        setTimeout(() => document.addEventListener('click', this.onOutside), 0);
      }

      close() {
        if (!this.panel || this.hasAttribute('data-inline')) return;
        this.panel.hidden = true;
        if (this.backdrop) this.backdrop.hidden = true;
        this.toggle?.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden-mobile');
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onOutside);
        this.toggle?.focus({ preventScroll: true });
      }

      onKey(event) {
        if (event.key === 'Escape') this.close();
      }

      onOutside(event) {
        if (!this.contains(event.target)) this.close();
      }

      // "#১০০১", " 1001 ", "#1001" → "1001"
      normalize(value) {
        return String(value || '')
          .replace(/[০-৯]/g, (d) => String('০১২৩৪৫৬৭৮৯'.indexOf(d)))
          .replace(/[#\s]/g, '')
          .trim();
      }

      showError(show) {
        if (!this.error) return;
        this.error.hidden = !show;
        this.input?.setAttribute('aria-invalid', String(Boolean(show)));
      }

      async lookup(event) {
        event.preventDefault();
        const number = this.normalize(this.input.value);
        if (!/^[0-9]{1,12}$/.test(number)) {
          this.showError(true);
          this.input.focus();
          return;
        }
        this.showError(false);
        this.input.value = number;
        this.submit?.classList.add('is-loading');
        this.submit?.setAttribute('aria-busy', 'true');

        try {
          const params = new URLSearchParams({ q: number, type: 'page', section_id: 'bd-order-status' });
          const response = await fetch(`${this.dataset.searchUrl}?${params}`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.querySelector('[data-order-result]');
          if (!result) throw new Error('No result');
          this.result.replaceChildren(document.importNode(result, true));
          // Let the line grow from 0 to the current step
          const steps = this.result.querySelector('.bd-ot-steps');
          if (steps) requestAnimationFrame(() => requestAnimationFrame(() => steps.classList.add('is-ready')));
        } catch (error) {
          this.result.innerHTML = '';
          this.showError(true);
        } finally {
          this.submit?.classList.remove('is-loading');
          this.submit?.removeAttribute('aria-busy');
        }
      }
    }
  );
}

/* Any link with data-bd-track-open (phone drawer, bottom bar) opens the header tracking panel.
   Registered once, even though the script is included by both the header and the tracking page. */
if (!window.bdTrackOpenReady) {
  window.bdTrackOpenReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bd-track-open]');
    if (!trigger) return;
    const tracker = document.querySelector('bd-order-track.bd-ot--header');
    if (!tracker || typeof tracker.open !== 'function') return; // no panel → normal link to /pages/track-order
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('bd:close-drawers'));
    if (!tracker.isOpen()) tracker.open();
  });
}
